import type { IconData } from '@stacksjs/iconify-core'

export const italic: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 496h480V16H16ZM48 48h416v416H48Z\"/><path fill=\"currentColor\" d=\"M200 143.998h44.442l-42 224H152v32h160v-32h-44.442l42-224H360v-32H200z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default italic
